<template><JobOrderForm ref="form" /></template>
<script>
import JobOrderForm from './JobOrderForm'
export default {
    components: { JobOrderForm },
    mounted() { this.$refs.form.openDialog(this.$route.params.id) }
}
</script>
